
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "./Tooltip.js";


function CopyTextUniversalButton({ smiles, copiedText = "smiles" }) {

      function handleClickSmiles(e) {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(smiles)            
      }


  return (
    <Tooltip content={`Copy ${copiedText} to clipboard`}>
      <button
        style={{
          border: "none",
          backgroundColor: "rgb(245,245,245, 0)",
          padding: 0,
          margin: 0,
        }}
        onClick={handleClickSmiles}
      >
        <FontAwesomeIcon icon={faCopy}  />
      </button>
    </Tooltip>
  );
}

export default CopyTextUniversalButton;
